import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import { Router } from '@angular/router';
import { AuthenticationService } from '../auth/_services/authentication.service';
import { environment } from '../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private _injector: Injector, private _router: Router) {}

  // INTERCEPTOR FOR API CALLS----------------------------------------------------
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const auth = this._injector.get(AuthenticationService);
    const userObj = JSON.parse(localStorage.getItem('CURRENT_USER'));
    const authToken = userObj ? userObj.token : '';
    let newRequest;
    if (!request.url.includes('open.getvero.com')) {
      if (
        !(
          request.url.includes('/api/') ||
          request.url.includes('/cellphone/') ||
          request.url.includes('/bundle/') ||
          request.url.includes('/insurance/')
        )
      ) {
        // Note: passing employee token below works as BOTH customer & employee tokens
        // are generated using same jwt secret
        newRequest = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + environment.API_GATEWAY_TOKEN,
            BT_Authorization: authToken
          }
        });
      } else if (request.url.includes('/autopilot')) {
        newRequest = request.clone({
          setHeaders: {
            Authorization: 'Bearer ' + environment.AUTOPILOT_GATEWAY_TOKEN,
            BT_Authorization: authToken
          }
        });
      } else {
        newRequest = request.clone({
          setHeaders: {
            Authorization: 'Token ' + authToken
            // 'Content-Type': 'application/json'
          }
        });
      }
    } else {
      newRequest = request.clone();
    }

    if (newRequest.method === 'POST' && newRequest.body) {
      const CURRENT_USER = JSON.parse(localStorage.getItem('CURRENT_USER'));
      newRequest.body.apiSource = {
        _id: CURRENT_USER._id,
        actorName: CURRENT_USER.fullName,
        actorType: CURRENT_USER.type
      };
    }
    return next
      .handle(newRequest)
      .do(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // console.log('User is authorized!'); // if authorized
          }
        },
        (err: HttpErrorResponse) => {
          // if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            // redirect to the login
            auth.logout();
            this._router.navigate(['/login']);
          } else if (
            err.error &&
            err.error.error &&
            err.error.error.includes('Invalid Authorization')
          ) {
            auth.logout();
            this._router.navigate(['/login']);
          }

          // }
        },
        () => {}
      )
      .catch((err: HttpErrorResponse) => {
        if (err.status >= 200 && err.status < 300) {
          const res = new HttpResponse({
            body: null,
            headers: err.headers,
            status: err.status,
            statusText: err.statusText,
            url: err.url
          });
          return Observable.of(res);
        } else {
          return Observable.throw(err);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptor/app-token-interceptor.ts